















































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";
// Types
import { ITableConfig, IFilter, ISorter } from "@/models/tables";
import { InvoiceCategoryCode } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";
import {
  FilterTypes,
  FilterOperators,
  Sorters,
  ApiOperators
} from "@/data/table";
import { BACKEND_DATETIME_FORMAT } from "@/data/date";
import { ProductTypes } from "@/data/enums/products";
import { IBasketProduct } from "@/models/baskets";
import { IDynamicColumn } from "@/models/dynamicColumns";
import { DynamicColumns } from "@/mixins/dynamicColumns";
import StatusLabel from "@/components/base/StatusLabel.vue";
import Datetime from "@/components/base/Datetime.vue";
import UResizableTable from "@/components/app-base/UResizableTable.vue";
import { InvoiceStatus } from "@/data/enums/invoice";
import i18n from "@/i18n";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import dateRanges from "@/data/dateranges";

@Component({
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  },
  components: {
    UResizableTable,
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue")
  }
})
export default class InvoicesProductsTable extends Mixins(
  StatsStorageMixin,
  FilteringSortingTableStore,
  DynamicColumns,
  Context
) {
  public defaults: ITableConfig = {
    page: 1,
    limit: 50,
    sort: {
      field: "invoice_create_datetime",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  public isMultibrand!: boolean;
  public range = this.tryGetStatDateFromStorage(dateRanges.ranges.last30days);
  public defaultColumnWidth = "120px";

  public filters: IFilter[] = [
    {
      key: "invoice.category.slug",
      label: i18n.t("_.category"),
      type: FilterTypes.SELECT_CHECKBOX,
      options: [
        {
          value: InvoiceCategoryCode.NEW_CONTRACT,
          label: i18n.t("_.new_contract")
        },
        {
          value: InvoiceCategoryCode.RECURRENT,
          label: i18n.t("_.recurrent")
        },
        {
          value: InvoiceCategoryCode.CREDIT_NOTE,
          label: i18n.t("_.credit_note")
        },
        {
          value: InvoiceCategoryCode.CREDIT_NOTE_FOR_REFUND,
          label: i18n.t("_.credit_note_for_refund")
        }
      ],
      operator: FilterOperators.EQUAL
    },
    {
      key: "invoice.status.code",
      label: i18n.t("_.status"),
      type: FilterTypes.SELECT_CHECKBOX,
      options: [
        { value: InvoiceStatus.PAID, label: i18n.t("_.paid") },
        { value: InvoiceStatus.UNPAID, label: i18n.t("_.unpaid") },
        { value: InvoiceStatus.OVERDUE, label: i18n.t("_.overdue") },
        { value: InvoiceStatus.CANCELLED, label: i18n.t("_.cancelled") },
        { value: InvoiceStatus.REFUNDED, label: i18n.t("_.refunded") },
        { value: InvoiceStatus.ADJUSTED, label: i18n.t("_.adjusted") }
      ],
      operator: FilterOperators.EQUAL
    },
    {
      key: "invoice.create_datetime",
      label: i18n.t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public availableColumns: IDynamicColumn[] = [
    {
      id: "invoice_brand",
      field: "invoice_brand.name",
      label: i18n.t("_.brand"),
      if: function(vm) {
        return !!vm.isMultibrand;
      }
    },
    {
      id: "status",
      label: i18n.t("_.status"),
      component: StatusLabel,
      props: (row: any) => ({
        key: row.id,
        type: "invoice",
        status: row?.invoice_status?.code
      })
    },
    {
      id: "client",
      label: i18n.t("_.client"),
      component: "u-client-link",
      props: (row: any) => ({
        clientId: this.$_.get(row, "invoice_client_id"),
        client: this.$_.get(row, "client"),
        to: "adminClientInvoices",
        class: "has-text-dark"
      }),
      thAttr: {
        class: "is-compact",
        style: { width: "200px" }
      }
    },
    {
      id: "invoice_number",
      label: i18n.t("_.invoice_number"),
      component: "u-invoice-link",
      field: "invoice_number",
      props: (row: any) => ({
        invoiceId: row.invoice_id,
        clientId: row.client_id,
        class: "has-text-underlined has-text-black"
      })
    },
    {
      id: "id",
      field: "id",
      label: i18n.t("_.id")
    },
    {
      id: "main_invoice_product_id",
      function: row => row.main_invoice_product_id || "-",
      label: i18n.t("_.main_invoice_product_id")
    },
    {
      id: "item_type",
      function: this.getTypeName,
      label: i18n.t("_.item_type")
    },
    {
      id: "product_id",
      label: i18n.t("_.product_id"),
      component: "u-product-link",
      field: "product.id",
      props: (row: any) => ({
        "product-id": row.product?.id,
        classes: "has-text-underlined has-text-black"
      })
    },
    {
      id: "category",
      function: row =>
        row.product?.category?.name_translated || row.product?.category?.name,
      label: i18n.t("_.category")
    },
    {
      id: "product",
      label: i18n.t("_.product"),
      component: "u-product-link",
      field: "product_name",
      props: (row: any) => ({
        "product-id": row.product?.id,
        classes: "has-text-underlined has-text-black"
      })
    },
    {
      id: "selling_price",
      function: row =>
        this.isAttribute(row) ? "-" : row.selling_price_formatted,
      label: i18n.t("_.selling_price")
    },
    {
      id: "quantity",
      field: "quantity",
      label: i18n.t("_.quantity")
    },
    {
      id: "total",
      function: row =>
        this.isAttribute(row) ? "-" : row.total_amount_formatted,
      label: i18n.t("_.total")
    },
    {
      id: "created",
      label: i18n.t("_.created"),
      component: Datetime,
      props: (row: any) => ({
        key: row.id,
        datetime: row.invoice_create_datetime
      })
    },
    {
      id: "currency",
      function: row => (this.isAttribute(row) ? "-" : row.base_currency_code),
      label: i18n.t("_.currency")
    },
    {
      id: "discount",
      function: row =>
        this.isAttribute(row) ? "-" : row.total_discount_amount_formatted,
      label: i18n.t("_.discount")
    }
  ];

  public defaultColumns: string[] = [
    "invoice_brand",
    "status",
    "client",
    "invoice_number",
    "id",
    "main_invoice_product_id",
    "item_type",
    "product_id",
    "category",
    "product",
    "selling_price",
    "quantity",
    "total",
    "created",
    "currency",
    "discount"
  ];

  public sorters: ISorter[] = [
    {
      field: "invoice_create_datetime",
      label: this.$t("_.created")
    },
    {
      field: "invoice_number",
      label: this.$t("_.invoice_number")
    },
    {
      field: "total_amount",
      label: this.$t("_.total")
    },
    {
      field: "invoice_status",
      label: this.$t("_.status")
    }
  ];

  public dataModule: string = DataModules.INVOICES;
  public dataModuleAction = "listProducts";

  public created() {
    this.apiProps = { with: "product" };
    this.getData();
  }

  // overrides mixin method
  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(params, {
      params: {
        ...params.filter,
        ...this.startDateFilter,
        ...this.endDateFilter
      }
    });
  }

  @Watch("range")
  public rangeChanged() {
    this.getData();
  }

  public get startDateFilter() {
    if (!this.range.dateFrom) {
      return {};
    }
    return {
      [`filter[invoice.create_datetime|${ApiOperators.GREATER_THAN_OR_EQUAL_TO}]`]: this.$moment(
        this.range.dateFrom
      )
        .startOf("minute")
        .format(BACKEND_DATETIME_FORMAT)
    };
  }

  public get endDateFilter() {
    if (!this.range.dateTo) {
      return {};
    }
    return {
      [`filter[invoice.create_datetime|${ApiOperators.LESS_THAN_OR_EQUAL_TO}]`]: this.$moment(
        this.range.dateTo
      )
        .endOf("minute")
        .format(BACKEND_DATETIME_FORMAT)
    };
  }

  public getTypeName(invoiceProduct: IBasketProduct) {
    if (
      invoiceProduct?.product?.product_type === ProductTypes.PRODUCT_ATTRIBUTE
    ) {
      return this.$t("_.attribute");
    }
    if (invoiceProduct?.product?.product_type === ProductTypes.PRODUCT_OPTION) {
      return this.$t("_.option");
    }
    return this.$t("_.product");
  }

  public isAttribute(invoiceProduct: IBasketProduct) {
    return (
      invoiceProduct.product.product_type === ProductTypes.PRODUCT_ATTRIBUTE
    );
  }
}
